import { render } from "./TipTapEditor.vue?vue&type=template&id=65c481b3&ts=true"
import script from "./TipTapEditor.vue?vue&type=script&lang=ts"
export * from "./TipTapEditor.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__